import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import Button from 'components/Button';
import Title from 'components/Title';

import styles from './Subscription.module.css';

const cx = classNames.bind(styles);

const width = window.outerWidth || window.innerWidth;
const isMobile = width <= 600;

export default class Subscription extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    isLoading: PropTypes.bool,
    submitBtn: PropTypes.string,
    cancelBtn: PropTypes.string,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    isAfterRestore: PropTypes.bool,
    isSessionOver: PropTypes.bool
  }

  static defaultProps = {
    children: null,
    isLoading: false,
    submitBtn: null,
    cancelBtn: null,
    onCancel: () => { },
    onSubmit: () => { },
    isAfterRestore: false,
    isSessionOver: false
  }

  render() {
    const {
      submitBtn,
      cancelBtn,
      onSubmit,
      onCancel,
      isLoading,
      isAfterRestore,
      isSessionOver
    } = this.props;

    return (
      <form className={cx('subscription', {subscription_afterRestore: isAfterRestore, subscription_sessionOver: isSessionOver})} onSubmit={onSubmit}>
        {isAfterRestore && isMobile && <div></div>}
        <div className={cx('title')}>
          <Title size='small' isAfterRestore={isAfterRestore}>
            {this.props.children}
          </Title>
        </div>

        {(submitBtn || cancelBtn) &&
          <div className={cx('buttons', {buttons_afterRestore: isAfterRestore})}>
            {submitBtn &&
              <div className={cx('button')}>
                <Button
                  isLoading={isLoading}
                  disabled={isLoading}
                  type='submit'
                  upper
                  bordered
                  block
                >
                  {submitBtn}
                </Button>
              </div>
            }
            {cancelBtn &&
              <div className={cx('button', {button_afterRestore: isAfterRestore})}>
                <Button
                  onClick={onCancel}
                  upper={!isAfterRestore}
                  bordered
                  block
                  customClass={isAfterRestore && 'button--registration'}
                >
                  {cancelBtn}
                </Button>
              </div>
            }
          </div>
        }
      </form>
    );
  }
}
